import { ISymbolListResponseCounters } from '@cbridge-utils/datagrid';
import { makeCompositeId } from '@cbridge-utils/formatters';
import { IClientLp } from '@cbridge-packages/lp-client';
import { LpSymbolsFilter, ISymbolLpKey } from '../symbolLp.interface';

interface ICounterCacheParams {
  lpId: IClientLp['lpId'];
  symbolGroup?: string;
  filter?: LpSymbolsFilter;
  search?: string;
}

export const makeLpSymbolCountersCacheId = (params: ICounterCacheParams) => {
  const {
    lpId,
    symbolGroup = '-',
    filter = '-',
    search = '-',
  } = params;

  return makeCompositeId([lpId, symbolGroup, filter, search]);
};

type ICountersData = [string, ISymbolListResponseCounters];

export const makeLpSymbolCountersCache = <R extends ISymbolListResponseCounters>(request: ISymbolLpKey, response: R): ICountersData => {
  const { filteredCount, totalCount, unmappedCount } = response;

  return [
    makeLpSymbolCountersCacheId(request),
    { filteredCount, totalCount, unmappedCount },
  ];
};
